import { apiBaseURL } from './api'

/**
 * Resolve an internal asset reference to a URL the browser/WebView can load.
 *
 * Backend-stored asset references are relative `/api/assets/{id}` paths. On the
 * web PWA these resolve same-origin and work as-is. In the native (Capacitor)
 * WebView the app is served from a Capacitor origin, so `/api/...` would resolve
 * to the app bundle, not the backend — we must make them absolute against the
 * configured API base.
 *
 * Only rewrites our own `/api/assets/` paths; external/absolute URLs
 * (YouTube/Vimeo, https links) and data/blob URLs are returned unchanged.
 */
export function resolveAssetUrl(url: string | null | undefined): string {
  if (!url) return ''
  if (url.startsWith('/api/')) {
    // apiBaseURL() ends with `/api`; strip the duplicate prefix.
    const base = apiBaseURL().replace(/\/api$/, '')
    return `${base}${url}`
  }
  return url
}
